import { useQuery } from '@apollo/client';
import * as Schema from 'generated/graphql/schema';
import React, { useState } from 'react';

import GroupsSideBar from '@/components/bars/groups-sidebar';
import ContextTimepickerWrapper from '@/contexts/timepicker';
import { consolidatedGroupsLines } from '@/graphql/queries';
import { getYearWeek } from '@/helpers/schedule';
import { useIAM } from '@/hooks/use-iam';
import * as Types from '@/types';
import ConsolidatedOEEGrid from '@/views/consolidated-lines/consolidated-oee-grid';
import NoGroupSelected from '@/views/consolidated-lines/no-group-selected';

const thisWeek = getYearWeek(new Date());

const ConsolidatedLinesPage = () => {
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);
  const { hasGroupFeatures } = useIAM();
  const { loading, data } = useQuery<Schema.ConsolidatedGroupsLinesQuery, Schema.ConsolidatedGroupsLinesQueryVariables>(
    consolidatedGroupsLines,
    {
      partialRefetch: true,
      errorPolicy: 'all',
      ssr: false,
      variables: { validIn: thisWeek },
    },
  );

  const onSelectGroup = (groupId: string) => setSelectedGroupId(groupId);
  const groupsWithLines = (data?.user.groups ?? [])
    .filter((group) => group.lines.length)
    .filter((g) => hasGroupFeatures(g.id, ['Lines.Line'], 'Q'));

  const selectedGroup = groupsWithLines.find((group) => group.id === selectedGroupId) || null;
  return (
    <div style={{ display: 'flex', position: 'relative', height: '100%' }}>
      {selectedGroup ? (
        <ContextTimepickerWrapper>
          <ConsolidatedOEEGrid lines={selectedGroup.lines.filter(Types.isTruthy)} />
        </ContextTimepickerWrapper>
      ) : (
        <NoGroupSelected />
      )}

      <GroupsSideBar
        selectedGroupId={selectedGroupId}
        groups={groupsWithLines}
        groupsLoading={loading}
        onSelectGroup={onSelectGroup}
      />
    </div>
  );
};

export default ConsolidatedLinesPage;
